<template>
    <v-card class="weekly-item rounded-xl white overflow-hidden" elevation="0" @click="goToProduct"
        hover>
        <div class="pa-2 fill-height image-wrapper">
            <!-- Rank Badge -->
            <div class="rank-badge" :class="rankClass">
                #{{ rank + 1 }}
            </div>

            <!-- Sold Badge -->
            <div class="sold-overlay">
                <v-icon size="11" color="white">mdi-fire</v-icon>
                {{ product.totalSold }} ชิ้น
            </div>

            <!-- Product Image -->
            <v-img :src="getProductImage" aspect-ratio="1" contain class="white rounded-xl">
                <template #placeholder>
                    <div class="d-flex align-center justify-center fill-height" style="background: #f0f0f0;">
                        <v-progress-circular indeterminate color="#198C19" />
                    </div>
                </template>
                <template #error>
                    <div class="d-flex align-center justify-center fill-height" style="background: #f0f0f0;">
                        <v-icon color="grey-lighten-3" size="36">mdi-shopping</v-icon>
                    </div>
                </template>
            </v-img>
        </div>
    </v-card>
</template>

<script>
import { getProductImage } from "@/utils/image";

export default {
    name: "WeeklyProductCard",
    props: {
        product: {
            type: Object,
            required: true
        },
        rank: {
            type: Number,
            required: true
        }
    },
    computed: {
        getProductImage() {
            return getProductImage(this.product);
        },
        rankClass() {
            if (this.rank === 0) return "rank-gold";
            if (this.rank === 1) return "rank-silver";
            if (this.rank === 2) return "rank-bronze";
            return "rank-default";
        }
    },
    methods: {
        goToProduct() {
            this.$router.push({ name: "product_detail", params: { id: this.product.id } });
        }
    }
};
</script>

<style scoped>
/* Product Card */
.weekly-item {
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
}

.image-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-wrapper > .v-image {
    width: 100%;
}
:deep(.v-image__image--contain) {
    background-size: contain;
    background-position: center center !important;
}

.weekly-item:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
}

.image-placeholder {
    background: #f0f0f0;
    height: 100%;
    min-height: 100px;
}

/* Rank Badge */
.rank-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    font-size: 11px;
    font-weight: 800;
    padding: 2px 7px;
    border-radius: 20px;
    letter-spacing: 0.5px;
}

.rank-gold {
    background: #FFD700;
    color: #5a4000;
}

.rank-silver {
    background: #C0C0C0;
    color: #3a3a3a;
}

.rank-bronze {
    background: #CD7F32;
    color: #fff;
}

.rank-default {
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
}

/* Sold overlay badge */
.sold-overlay {
    position: absolute;
    bottom: 8px;
    right: 8px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: linear-gradient(135deg, #ef5350, #e53935);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 20px;
}
</style>
